import { render, staticRenderFns } from "./Collapsable.vue?vue&type=template&id=26b232ac&scoped=true"
import script from "./Collapsable.vue?vue&type=script&lang=js"
export * from "./Collapsable.vue?vue&type=script&lang=js"
import style0 from "./Collapsable.vue?vue&type=style&index=0&id=26b232ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b232ac",
  null
  
)

export default component.exports